import styled from 'vue-styled-components'

const GridTool = styled.div`
pointer-events: all;
  position: absolute;
  width: fit-content;
  padding: 5px;
  border-radius: 0px 0px 0px 5px;
  right: 0;
  /* opacity: 0; */
  z-index: 10;
  font-weight: 500;
  transition: all 0.1s ease;
  line-height: 1;
  font-size: 16px;
  margin-right: 4px;
  & > div {
    cursor: pointer;
    margin: 2px;
    border: 1px solid #DFDFDF;
    border-radius: 50%;
    background-color: white;
    color: var(--paragraph);
    font-size: 16px;
    line-height: 1;
    padding: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
    width: 32px;
    height: 32px;
  }
`;

const WrapperProps = {
  position: {},
  isActiveWidget: false
}
const Wrapper = styled('div', WrapperProps)`
pointer-events: none;
position: absolute;
width: ${({ position }) => position.width};
height: ${({ position }) => position.height};
top: ${({ position }) => position.top};
left: ${({ position }) => position.left};
z-index: 6;
&::after {
  position: absolute;
  content: '';
  width: 100%;
  height: 100%;
  border: ${({isActiveWidget}) => isActiveWidget ? '1px solid #A9A9A9' : '2px solid #12A9FF'};
  z-index: 4;
}
/* border: 3px solid red; */

.lbl-name {
  bottom: 100%;
}

.grid-tool {
  bottom: 100%;
}

// &.top {
//   .grid-tool {
//     bottom: 100%;
//   }
// }
// &.bottom {
//   .grid-tool {
//     top: 100%;
//   }
// }

`
export {
  GridTool,
  Wrapper
}